import React from "react";
import { Box, Typography, Button, Alert } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import DownloadIcon from "@mui/icons-material/Download";
import UploadIcon from "@mui/icons-material/Upload";
import { useTranslation } from "react-i18next";
import { API_KEYS } from '../config';

export default function BackupSettingsPage() {
  const { t } = useTranslation();

  const handleExport = async () => {
    try {
      const res = await fetch("/api/backup/export-sql", {
        method: "GET",
        headers: {
          'x-api-key': API_KEYS.key,
          'x-api-secret': API_KEYS.secret
        }
      });
      if (!res.ok) throw new Error("Export failed");
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "webdesk-backup.sql";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      alert(t("settings.backup.exportError") + ": " + e.message);
    }
  };

  const handleImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file); // correspond au paramètre UploadFile = File(...) côté backend
    try {
      const res = await fetch("/api/backup/import-sql", {
        method: "POST",
        headers: {
          'x-api-key': API_KEYS.key,
          'x-api-secret': API_KEYS.secret
        },
        body: formData
      });
      if (!res.ok) {
        let msg = "Import failed";
        try {
          const json = await res.json();
          msg = json.detail || json.message || msg;
        } catch {}
        throw new Error(msg);
      }
      alert(t("settings.backup.importSuccess"));
      window.location.reload();
    } catch (e) {
      alert(t("settings.backup.importError") + ": " + e.message);
    }
  };

  const handleClick = () => {
    // This function is not defined in the original code, 
    // so I'm assuming it's supposed to be defined here.
    // You should replace this with your actual handleClick function.
  };

  return (
    <Box sx={{ p: 4, maxWidth: 480, mx: "auto" }}>
      <Box display="flex" alignItems="center" mb={2}>
        <SaveIcon fontSize="large" color="primary" sx={{ mr: 1 }} />
        <Typography variant="h5">{t("desktop.backup-settings")}</Typography>
      </Box>
      <Typography variant="body1" color="text.secondary" mb={3}>
        {t("settings.backup.desc")}
      </Typography>
      <Box display="flex" flexDirection="column" gap={2}>
        <Button variant="contained" startIcon={<DownloadIcon />} onClick={handleExport}>
          {t("settings.backup.export")}
        </Button>
        <label htmlFor="db-import">
          <input id="db-import" type="file" accept=".sql" style={{ display: "none" }} onChange={handleImport} />
          <Button variant="contained" startIcon={<UploadIcon />} component="span">
            {t("settings.backup.import")}
          </Button>
        </label>
      </Box>
      <Alert severity="info" sx={{ mt: 3 }}>
        {t("settings.backup.desc")}
      </Alert>
    </Box>
  );
}
